<template>
  <div class="radio-group">
    <p class="subtitle-2 grey--text text--darken-1 mb-0 mt-3" v-text="data.text"></p>
    <p class="text-caption mb-2 grey--text text--darken-1" v-text="data.placeholder"></p>
    <v-radio-group v-model="data.value" class="mt-0" hide-details>
      <v-radio
        v-for="(opt, key) in data.options"
        :key="key"
        :label="opt.text"
        :value="opt.value"
      ></v-radio>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  name: "Radio",
  props: {
    data: {
      type: Object,
      required: true
    }
  }
};
</script>

<style>
</style>